import Vue from 'vue'

Vue.filter('transformInDate', text => {
  const date = new Date(text)
  const dayWithZero = `0${date.getDay()}`
  const day = dayWithZero.slice(-2)
  const month = date.getMonth()
  const year = date.getFullYear()
  return `${day}/${month}/${year}`
})